export default __webpack_public_path__ + "static/media/thum_2.da3d8165.png";